export const neasc = {
  title: "NEASC International Accreditation",
  subtitle: "Gándara International School is accredited by the New England Association of Schools and Colleges (NEASC), one of the world's most prestigious educational accreditation organizations.",
  badge: "NEASC Accredited School",
  learnMore: "Learn more about NEASC",
  learnMoreUrl: "https://www.neasc.org",
  benefits: {
    quality: {
      title: "Quality Assurance",
      description: "External and independent verification that we meet the highest international educational standards."
    },
    recognition: {
      title: "Global Recognition",
      description: "Our diplomas and certificates are recognized by educational institutions worldwide."
    },
    improvement: {
      title: "Continuous Improvement",
      description: "Permanent commitment to evaluation and improvement of our programs, facilities and methodologies."
    },
    transferability: {
      title: "Transferability",
      description: "Facilitates student transition to other accredited schools in Spain and abroad."
    }
  }
};
